<script>
  import { Footer } from 'element-ui'
  export default {
    name:'ElFooter',
    extends:Footer
  }
</script>
